"use strict";
import R from "./index.es145.js";
const { toString: T } = Object.prototype, { getPrototypeOf: w } = Object, { iterator: O, toStringTag: S } = Symbol, g = /* @__PURE__ */ ((e) => (r) => {
  const t = T.call(r);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), l = (e) => (e = e.toLowerCase(), (r) => g(r) === e), h = (e) => (r) => typeof r === e, { isArray: p } = Array, f = h("undefined");
function y(e) {
  return e !== null && !f(e) && e.constructor !== null && !f(e.constructor) && a(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const x = l("ArrayBuffer");
function k(e) {
  let r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(e) : r = e && e.buffer && x(e.buffer), r;
}
const D = h("string"), a = h("function"), P = h("number"), b = (e) => e !== null && typeof e == "object", M = (e) => e === !0 || e === !1, d = (e) => {
  if (g(e) !== "object")
    return !1;
  const r = w(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(S in e) && !(O in e);
}, N = (e) => {
  if (!b(e) || y(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, U = l("Date"), v = l("File"), q = l("Blob"), H = l("FileList"), I = (e) => b(e) && a(e.pipe), K = (e) => {
  let r;
  return e && (typeof FormData == "function" && e instanceof FormData || a(e.append) && ((r = g(e)) === "formdata" || // detect form-data instance
  r === "object" && a(e.toString) && e.toString() === "[object FormData]"));
}, V = l("URLSearchParams"), [$, z, J, W] = ["ReadableStream", "Request", "Response", "Headers"].map(l), _ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function m(e, r, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), p(e))
    for (n = 0, o = e.length; n < o; n++)
      r.call(null, e[n], n, e);
  else {
    if (y(e))
      return;
    const s = t ? Object.getOwnPropertyNames(e) : Object.keys(e), i = s.length;
    let c;
    for (n = 0; n < i; n++)
      c = s[n], r.call(null, e[c], c, e);
  }
}
function B(e, r) {
  if (y(e))
    return null;
  r = r.toLowerCase();
  const t = Object.keys(e);
  let n = t.length, o;
  for (; n-- > 0; )
    if (o = t[n], r === o.toLowerCase())
      return o;
  return null;
}
const u = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, C = (e) => !f(e) && e !== u;
function j() {
  const { caseless: e, skipUndefined: r } = C(this) && this || {}, t = {}, n = (o, s) => {
    const i = e && B(t, s) || s;
    d(t[i]) && d(o) ? t[i] = j(t[i], o) : d(o) ? t[i] = j({}, o) : p(o) ? t[i] = o.slice() : (!r || !f(o)) && (t[i] = o);
  };
  for (let o = 0, s = arguments.length; o < s; o++)
    arguments[o] && m(arguments[o], n);
  return t;
}
const G = (e, r, t, { allOwnKeys: n } = {}) => (m(r, (o, s) => {
  t && a(o) ? e[s] = R(o, t) : e[s] = o;
}, { allOwnKeys: n }), e), Q = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), X = (e, r, t, n) => {
  e.prototype = Object.create(r.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: r.prototype
  }), t && Object.assign(e.prototype, t);
}, Y = (e, r, t, n) => {
  let o, s, i;
  const c = {};
  if (r = r || {}, e == null) return r;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      i = o[s], (!n || n(i, e, r)) && !c[i] && (r[i] = e[i], c[i] = !0);
    e = t !== !1 && w(e);
  } while (e && (!t || t(e, r)) && e !== Object.prototype);
  return r;
}, Z = (e, r, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= r.length;
  const n = e.indexOf(r, t);
  return n !== -1 && n === t;
}, ee = (e) => {
  if (!e) return null;
  if (p(e)) return e;
  let r = e.length;
  if (!P(r)) return null;
  const t = new Array(r);
  for (; r-- > 0; )
    t[r] = e[r];
  return t;
}, re = /* @__PURE__ */ ((e) => (r) => e && r instanceof e)(typeof Uint8Array < "u" && w(Uint8Array)), te = (e, r) => {
  const t = (e && e[O]).call(e);
  let n;
  for (; (n = t.next()) && !n.done; ) {
    const o = n.value;
    r.call(e, o[0], o[1]);
  }
}, ne = (e, r) => {
  let t;
  const n = [];
  for (; (t = e.exec(r)) !== null; )
    n.push(t);
  return n;
}, oe = l("HTMLFormElement"), se = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, t, n) {
    return t.toUpperCase() + n;
  }
), A = (({ hasOwnProperty: e }) => (r, t) => e.call(r, t))(Object.prototype), ie = l("RegExp"), E = (e, r) => {
  const t = Object.getOwnPropertyDescriptors(e), n = {};
  m(t, (o, s) => {
    let i;
    (i = r(o, s, e)) !== !1 && (n[s] = i || o);
  }), Object.defineProperties(e, n);
}, ae = (e) => {
  E(e, (r, t) => {
    if (a(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const n = e[t];
    if (a(n)) {
      if (r.enumerable = !1, "writable" in r) {
        r.writable = !1;
        return;
      }
      r.set || (r.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, le = (e, r) => {
  const t = {}, n = (o) => {
    o.forEach((s) => {
      t[s] = !0;
    });
  };
  return p(e) ? n(e) : n(String(e).split(r)), t;
}, ce = () => {
}, ue = (e, r) => e != null && Number.isFinite(e = +e) ? e : r;
function fe(e) {
  return !!(e && a(e.append) && e[S] === "FormData" && e[O]);
}
const pe = (e) => {
  const r = new Array(10), t = (n, o) => {
    if (b(n)) {
      if (r.indexOf(n) >= 0)
        return;
      if (y(n))
        return n;
      if (!("toJSON" in n)) {
        r[o] = n;
        const s = p(n) ? [] : {};
        return m(n, (i, c) => {
          const F = t(i, o + 1);
          !f(F) && (s[c] = F);
        }), r[o] = void 0, s;
      }
    }
    return n;
  };
  return t(e, 0);
}, ye = l("AsyncFunction"), be = (e) => e && (b(e) || a(e)) && a(e.then) && a(e.catch), L = ((e, r) => e ? setImmediate : r ? ((t, n) => (u.addEventListener("message", ({ source: o, data: s }) => {
  o === u && s === t && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), u.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  a(u.postMessage)
), me = typeof queueMicrotask < "u" ? queueMicrotask.bind(u) : typeof process < "u" && process.nextTick || L, de = (e) => e != null && a(e[O]), ge = {
  isArray: p,
  isArrayBuffer: x,
  isBuffer: y,
  isFormData: K,
  isArrayBufferView: k,
  isString: D,
  isNumber: P,
  isBoolean: M,
  isObject: b,
  isPlainObject: d,
  isEmptyObject: N,
  isReadableStream: $,
  isRequest: z,
  isResponse: J,
  isHeaders: W,
  isUndefined: f,
  isDate: U,
  isFile: v,
  isBlob: q,
  isRegExp: ie,
  isFunction: a,
  isStream: I,
  isURLSearchParams: V,
  isTypedArray: re,
  isFileList: H,
  forEach: m,
  merge: j,
  extend: G,
  trim: _,
  stripBOM: Q,
  inherits: X,
  toFlatObject: Y,
  kindOf: g,
  kindOfTest: l,
  endsWith: Z,
  toArray: ee,
  forEachEntry: te,
  matchAll: ne,
  isHTMLForm: oe,
  hasOwnProperty: A,
  hasOwnProp: A,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: E,
  freezeMethods: ae,
  toObjectSet: le,
  toCamelCase: se,
  noop: ce,
  toFiniteNumber: ue,
  findKey: B,
  global: u,
  isContextDefined: C,
  isSpecCompliantForm: fe,
  toJSONObject: pe,
  isAsyncFn: ye,
  isThenable: be,
  setImmediate: L,
  asap: me,
  isIterable: de
};
export {
  ge as default
};
//# sourceMappingURL=index.es144.js.map
